export interface FilesProps {
  name: string;
  path: string;
  desc: string;
  date: string;
}
interface listProps {
  name: string;
  list: FilesProps[];
}
const base = window.location.pathname + "files/";
console.log(window.location.pathname, "location");

const list: listProps[] = [
  {
    name: "Taro",
    list: [
      {
        name: "【记录】微信小程序的一些特殊场景（Taro）",
        path: base + "Taro/【记录】微信小程序的一些特殊场景（Taro）",
        desc: "小程序对于特殊场景的一些api",
        date: "2023-12-16",
      },
    ],
  },
  {
    name: "TS",
    list: [
      {
        name: "TS学习记录",
        path: base + "TS/TS学习记录",
        desc: "Ts中常用的一些语法",
        date: "2020-10-21",
      },
    ],
  },
  {
    name: "Browser",
    list: [
      {
        name: "【记录】Cookie跨域",
        path: base + "Browser/【记录】Cookie跨域",
        desc: "关于跨域接口携带cookie",
        date: "2021-7-21",
      },
      {
        name: "浏览器缓存",
        path: base + "Browser/浏览器缓存",
        desc: "浏览器对于文件的获取方式",
        date: "2022-06-21",
      },
      {
        name: "【记录】浏览器渲染原理",
        path: base + "Browser/【记录】浏览器渲染原理",
        desc: "浏览器在输入url后，发生了什么？？",
        date: "2022-02-21",
      },
      {
        name: "JS事件循环",
        path: base + "Browser/JS事件循环",
        desc: "浏览器是怎么处理如此繁琐复杂的任务？？",
        date: "2021-06-21",
      },
    ],
  },
  {
    name: "download",
    list: [
      {
        name: "【记录】关于web、ios、android和taro小程序PDF预览和下载",
        path:
          base +
          "download/【记录】关于web、ios、android和taro小程序PDF预览和下载",
        desc: "各有千秋，但原理一致",
        date: "2023-12-26",
      },
    ],
  },
  {
    name: "ajax",
    list: [
      {
        name: "常见的请求头和响应头",
        path: base + "ajax/常见的请求头和响应头",
        desc: "我们经常看到的请求中，都有什么？？分别是什么意思？",
        date: "2022-12-26",
      },
    ],
  },
  {
    name: "engineer",
    list: [
      {
        name: "多语言自动化同步和jest自动检查",
        path: base + "engineer/多语言自动化同步和jest自动检查",
        desc: "多语言和unit test的工程化问题，规范开发的工作流程",
        date: "2024-2-26",
      },
      {
        name: "自动化mock",
        path: base + "engineer/自动化mock",
        desc: "服务端挂了咋办？前端推进受限？看这里一劳永逸",
        date: "2024-7-06",
      },
      {
        name: "icon自动化管理",
        path: base + "engineer/icon自动化管理",
        desc: "大量icon资源使用和管理繁琐？如果实现工程自动化？",
        date: "2024-7-25",
      },
      {
        name: "自动化约定路由",
        path: base + "engineer/自动化约定路由",
        desc: "大量页面路由使用和管理繁琐？如果实现工程自动化？",
        date: "2024-8-02",
      },
    ],
  },
  {
    name: "general",
    list: [
      {
        name: "NextJs学习记录",
        path: base + "general/NextJs学习记录",
        desc: "关于Next.js框架的学习笔记",
        date: "2024-4-10",
      },
      {
        name: "前端知识散点",
        path: base + "general/前端知识散点",
        desc: "关于前端需要知道的一些知识点",
        date: "2024-3-21",
      },
    ],
  },
];
export default list;
